import React from "react";
import "./home.css";
import Posts from "../../components/posts/Posts";

export default function Home() {
    return (
        <>
            <main id="main">
                <Posts />
            </main>
        </>
    );
}
